import { render, staticRenderFns } from "./MNPartnerTariff.vue?vue&type=template&id=04631d92&"
import script from "./MNPartnerTariff.vue?vue&type=script&lang=ts&"
export * from "./MNPartnerTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports